import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { OFFICE_KEY } from '@components/offices-dialog/offices-dialog';
import { TRANSPORTARE_FILTERS_KEY } from '@data-access/filters.data-access';
import { environment } from '@environments/environment.development';
import { tap } from 'rxjs';
import {
  TRANSPORTARE_AUTH,
  type UserAuth,
  type UserData,
  type UserDataToken,
} from 'src/app/core/infraestructure/interfaces/auth';
import { StorageDataAccess } from 'src/app/data-access/storage.data-access';

@Injectable({
  providedIn: 'root',
})
export class AuthDataAccess {
  dataUser = signal<UserAuth | null>(null);

  private http = inject(HttpClient);
  private storage = inject<StorageDataAccess<UserAuth>>(
    StorageDataAccess<UserAuth>,
  );

  constructor() {
    this.getdataUser();
  }

  logIng(data: UserData) {
    return this.http.post<UserAuth>(`${environment.apiUrl}/login`, data).pipe(
      tap((response) => {
        this.dataUser.set(response);
        this.storage.setItem(TRANSPORTARE_AUTH, response);
      }),
    );
  }

  logOut() {
    this.storage.removeItem(TRANSPORTARE_AUTH);
    this.storage.removeItem(OFFICE_KEY);
    this.storage.removeItem(TRANSPORTARE_FILTERS_KEY);
    this.dataUser.set(null);
  }

  isLogin() {
    const data = this.getdataUser();

    if (!data) {
      return false;
    }

    return !!data.token;
  }

  getdataUser() {
    const data = this.storage.getItem(TRANSPORTARE_AUTH);
    this.dataUser.set(data);
    return data;
  }

  getUserInfo() {
    const data = this.getdataUser();

    if (!data) return null;

    const response = JSON.parse(atob(data.token.split('.')[1]));
    return response.usuarioToken as UserDataToken;
  }

  isAuthenticated(): boolean {
    return !!this.dataUser();
  }
}
